// The 50 US states, as [abbreviation, name] pairs.
//
// ⚠️ ONE LIST, BECAUSE TWO LISTS DISAGREE. This lived privately inside
// PreQualification.js while the partner forms used free-text inputs — which is
// how partner_profiles.license_state came to hold both 'TX' (16 partners) and
// 'Tx' (3), and why the Partners table's State filter offered them as two
// different states. A control that accepts typing will eventually be typed into.
//
// ⚠️ THE ABBREVIATION IS THE STORED VALUE. Uppercase, two letters, and the ONLY
// thing that should ever reach the database — the name is for the person reading
// the dropdown. Anything that persists a state normalises to this shape; see
// backend/utils/normalizeState.js, which is the actual gate. A select is a
// convenience, not a constraint: the server still receives whatever a client
// chooses to send.
//
// DC and the territories are deliberately absent — this list backs real estate
// and mortgage LICENSE state pickers, and adding a jurisdiction Doorly does not
// lend in should be a decision, not a side effect of completeness.
export const US_STATES = [
  ['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],
  ['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['FL','Florida'],['GA','Georgia'],
  ['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],
  ['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],
  ['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],
  ['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],
  ['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],
  ['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],
  ['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],
  ['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming'],
];

export const STATE_ABBRS = US_STATES.map(([a]) => a);

export default US_STATES;

// ⚠️ THE ABBREVIATION IS WHAT IS STORED; THE NAME IS FOR READING. Staff surfaces
// show "Texas" rather than "TX" where there is room for it, and an unrecognised
// value comes back unchanged rather than blank — a stored code this list does not
// know is still better shown than swallowed.
export const stateName = (abbr) => {
  const hit = US_STATES.find(([a]) => a === String(abbr || '').toUpperCase());
  return hit ? hit[1] : (abbr || '');
};
